import _ from '@/utils/lodash-optimized'

export const findActive = location => {
  const { pathname } = location
  return pathname && `/${_.last(pathname.split('/'))}`
}
